import { render } from "./ProviderScoreChart.vue?vue&type=template&id=7cc634c6&scoped=true"
import script from "./ProviderScoreChart.vue?vue&type=script&lang=js"
export * from "./ProviderScoreChart.vue?vue&type=script&lang=js"

import "./ProviderScoreChart.vue?vue&type=style&index=0&id=7cc634c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc634c6"]])

export default __exports__